var React = require('react');

function DuplicateIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 5a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4v1h1a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-1H5a4 4 0 0 1-4-4V5zm15 0v1h-6a4 4 0 0 0-4 4v6H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2zm-6 16a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9zm4.5-10.75a.75.75 0 0 1 .75.75v2.75H18a.75.75 0 0 1 0 1.5h-2.75V18a.75.75 0 0 1-1.5 0v-2.75H11a.75.75 0 0 1 0-1.5h2.75V11a.75.75 0 0 1 .75-.75z","fill":"#fff"}));
}

DuplicateIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DuplicateIcon;

DuplicateIcon.default = DuplicateIcon;
